import { render, staticRenderFns } from "./WosData.vue?vue&type=template&id=6af70774&"
import script from "./WosData.vue?vue&type=script&lang=js&"
export * from "./WosData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports